// import { FiFileText, FiSearch, FiGlobe, FiLayers, FiAward, FiCheckCircle } from "react-icons/fi";

// const tenders = [
//   { id: "INT-TDR-2025-042", title: "Infrastructure Development — Road & Bridge Works", country: "Nigeria", sector: "Infrastructure", closing: "April 20, 2025", value: "USD 85 M", status: "Open" },
//   { id: "INT-TDR-2025-038", title: "Renewable Energy — Solar Farm Installation", country: "United Arab Emirates", sector: "Energy", closing: "May 05, 2025", value: "USD 120 M", status: "Open" },
//   { id: "INT-TDR-2025-031", title: "Manufacturing Unit — Automotive Components", country: "Germany", sector: "Manufacturing", closing: "May 18, 2025", value: "EUR 45 M", status: "Open" },
//   { id: "INT-TDR-2025-027", title: "Telecommunications — 5G Network Expansion", country: "South Korea", sector: "ICT / Telecom", closing: "June 01, 2025", value: "USD 200 M", status: "Open" },
//   { id: "INT-TDR-2025-021", title: "Healthcare — Hospital & Medical Equipment Supply", country: "Kenya", sector: "Healthcare", closing: "June 12, 2025", value: "USD 30 M", status: "Open" },
// ];

// const intelligence = [
//   "Real-time alerts from commercial missions",
//   "Sector-wise procurement tracking",
//   "Bidding support and documentation",
//   "Government portal access assistance",
//   "Market entry strategy for tenders",
// ];

// export default function Tenders() {
//   return (
//     <section id="tenders" className="scroll-mt-28 space-y-16">
//       <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#DB2628] to-[#DA2128] px-8 py-14 md:px-16 md:py-20 shadow-2xl shadow-[#DA2128]/20">
//         <div className="absolute -right-10 top-10 h-80 w-80 rounded-full bg-white/10 blur-3xl" />
//         <div className="absolute -left-10 bottom-0 h-56 w-56 rounded-full bg-white/10 blur-2xl" />
//         <div className="relative z-10 max-w-4xl">
//           <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-md border border-white/10">
//             <FiFileText className="h-4 w-4" /> Global Opportunities
//           </div>
//           <h2 className="font-['Cormorant_Garamond'] text-5xl md:text-7xl font-semibold text-white leading-[0.95] tracking-tight">
//             International <span className="italic font-normal">Tenders</span>
//           </h2>
//           <p className="mt-6 max-w-2xl text-lg text-white/90 leading-relaxed font-light">
//             Discerning global tender opportunities for ASSOCHAM members, curated from diplomatic missions, commercial offices, and government procurement portals worldwide.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-6 lg:grid-cols-3">
//         <div className="lg:col-span-2 space-y-4">
//           {tenders.map((t) => (
//             <a key={t.id} href="#" className="group flex flex-col md:flex-row md:items-center gap-6 rounded-2xl bg-white border border-[#FEF7F4] p-7 shadow-lg shadow-black/[0.03] hover:-translate-y-0.5 hover:shadow-xl hover:border-[#DA2128]/20 transition-all duration-300">
//               <div className="flex-shrink-0 h-16 w-16 rounded-2xl bg-gradient-to-br from-[#DA2128] to-[#DB2628] text-white flex items-center justify-center text-2xl shadow-lg shadow-[#DA2128]/20 group-hover:scale-110 transition-transform">
//                 <FiAward />
//               </div>
//               <div className="flex-1 min-w-0">
//                 <div className="flex flex-wrap gap-2 mb-2">
//                   <span className="text-xs font-bold text-[#DA2128] bg-[#DA2128]/10 px-2.5 py-0.5 rounded-full">{t.id}</span>
//                   <span className="text-xs font-semibold text-[#DB6400] bg-[#DB6400]/10 px-2.5 py-0.5 rounded-full">{t.status}</span>
//                 </div>
//                 <h4 className="text-lg font-semibold text-[#1a1a2e] mb-1 font-['Outfit'] group-hover:text-[#DA2128] transition-colors truncate">{t.title}</h4>
//                 <div className="flex flex-wrap gap-4 text-sm text-[#6a6a7a] font-medium">
//                   <span className="flex items-center gap-1.5"><FiGlobe className="h-3.5 w-3.5 text-[#DA2128]" /> {t.country}</span>
//                   <span className="flex items-center gap-1.5"><FiLayers className="h-3.5 w-3.5 text-[#DB6400]" /> {t.sector}</span>
//                   <span className="flex items-center gap-1.5"><FiFileText className="h-3.5 w-3.5" /> Closes {t.closing}</span>
//                 </div>
//               </div>
//               <div className="flex-shrink-0 text-right md:text-right">
//                 <div className="text-xl font-bold text-[#1a1a2e]">{t.value}</div>
//                 <div className="text-xs text-[#9a9aab] font-medium">Estimated Value</div>
//               </div>
//             </a>
//           ))}
//         </div>

//         <div className="rounded-3xl bg-gradient-to-b from-[#1a1a2e] to-[#2a2a40] p-10 text-white shadow-2xl shadow-black/20 h-fit">
//           <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10 text-white shadow-lg backdrop-blur-sm">
//             <FiSearch className="h-7 w-7" />
//           </div>
//           <h3 className="text-2xl font-semibold mb-4 font-['Outfit'] tracking-tight">Tender Intelligence</h3>
//           <ul className="space-y-4">
//             {intelligence.map((item) => (
//               <li key={item} className="flex items-start gap-3 text-sm text-white/80">
//                 <FiCheckCircle className="h-5 w-5 text-[#F59C00] flex-shrink-0 mt-0.5" />
//                 <span>{item}</span>
//               </li>
//             ))}
//           </ul>
//           <a href="#" className="mt-8 block w-full text-center rounded-full bg-[#F59C00] text-[#1a1a2e] font-bold py-3.5 shadow-xl shadow-[#F59C00]/25 hover:bg-[#FBBF24] transition-colors">Register for Tender Updates</a>
//         </div>
//       </div>
//     </section>
//   );
// }





// new code 





import { useState } from "react";
import { FiFileText, FiSearch, FiGlobe, FiLayers, FiAward, FiCheckCircle, FiArrowUpRight, FiZap, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";

const tenders = [
  { id: "INT-TDR-2025-042", title: "Infrastructure Development — Road & Bridge Works", country: "Nigeria", sector: "Infrastructure", closing: "Apr 20, 2025", value: "USD 85 M", status: "Open" },
  { id: "INT-TDR-2025-038", title: "Renewable Energy — Solar Farm Installation", country: "UAE", sector: "Energy", closing: "May 05, 2025", value: "USD 120 M", status: "Open" },
  { id: "INT-TDR-2025-031", title: "Manufacturing Unit — Automotive Components", country: "Germany", sector: "Manufacturing", closing: "May 18, 2025", value: "EUR 45 M", status: "Open" },
  { id: "INT-TDR-2025-027", title: "Telecommunications — 5G Network Expansion", country: "South Korea", sector: "ICT / Telecom", closing: "Jun 01, 2025", value: "USD 200 M", status: "Open" },
  { id: "INT-TDR-2025-021", title: "Healthcare — Hospital & Medical Equipment Supply", country: "Kenya", sector: "Healthcare", closing: "Jun 12, 2025", value: "USD 30 M", status: "Open" },
];

const intelligence = [
  "Real-time alerts from commercial missions",
  "Sector-wise procurement tracking",
  "Bidding support and documentation",
  "Government portal access assistance",
  "Market entry strategy for tenders",
];

export default function Tenders() {
  const [showAll, setShowAll] = useState(false);

  // Show 3 tenders initially, show all when toggled
  const visibleTenders = showAll ? tenders : tenders.slice(0, 3);

  return (
    <section id="tenders" className="scroll-mt-20 py-4 max-w-7xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 border-b border-gray-100 pb-5">
        <div>
          <div className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-[#DA2128]/10 px-3 py-1 text-xs font-semibold text-[#DA2128]">
            <FiZap className="h-3.5 w-3.5 animate-pulse" />
            <span>Global Opportunities</span>
          </div>
          <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-semibold text-[#1a1a2e] leading-tight tracking-tight">
            International <span className="italic font-normal text-[#F59C00]">Tenders</span>
          </h2>
        </div>
        <p className="max-w-md text-xs text-[#6a6a7a] leading-relaxed font-light">
          Discerning global tender opportunities for ASSOCHAM members, curated from diplomatic missions and government portals.
        </p>
      </div>

      {/* Main Grid Section */}
      <div className="grid gap-6 lg:grid-cols-3 items-start">
        {/* Tender List Column */}
        <div className="lg:col-span-2 space-y-3">
          <motion.div layout className="space-y-3">
            <AnimatePresence>
              {visibleTenders.map((t) => (
                <motion.a
                  key={t.id}
                  href="#"
                  layout
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.3 }}
                  className="group relative flex flex-col sm:flex-row sm:items-center justify-between gap-4 rounded-xl bg-white border border-[#FEF7F4] p-4 shadow-sm hover:shadow-md hover:border-[#DA2128]/30 transition-all duration-300 overflow-hidden"
                >
                  <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#DA2128] via-[#DB6400] to-[#F59C00] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />

                  <div className="flex items-start gap-3.5 min-w-0">
                    <div className="shrink-0 h-10 w-10 rounded-lg bg-gradient-to-br from-[#DA2128] to-[#DB2628] text-white flex items-center justify-center text-lg shadow-md shadow-[#DA2128]/20 group-hover:scale-105 transition-transform">
                      <FiAward />
                    </div>

                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-[10px] font-bold text-[#DA2128] bg-[#DA2128]/10 px-2 py-0.5 rounded-md">{t.id}</span>
                        <span className="text-[10px] font-semibold text-[#DB6400] bg-[#DB6400]/10 px-2 py-0.5 rounded-md">{t.status}</span>
                      </div>

                      <h3 className="text-sm font-semibold text-[#1a1a2e] font-['Outfit'] group-hover:text-[#DA2128] transition-colors truncate">
                        {t.title}
                      </h3>

                      <div className="flex flex-wrap items-center gap-3 mt-1.5 text-xs text-[#6a6a7a] font-medium">
                        <span className="flex items-center gap-1"><FiGlobe className="h-3 w-3 text-[#DA2128]" /> {t.country}</span>
                        <span className="flex items-center gap-1"><FiLayers className="h-3 w-3 text-[#DB6400]" /> {t.sector}</span>
                        <span className="flex items-center gap-1 text-[#9a9aab]"><FiFileText className="h-3 w-3" /> {t.closing}</span>
                      </div>
                    </div>
                  </div>

                  <div className="flex sm:flex-col items-center sm:items-end justify-between border-t sm:border-t-0 pt-2 sm:pt-0 border-gray-100 shrink-0 text-right">
                    <div className="text-base font-bold text-[#1a1a2e]">{t.value}</div>
                    <div className="text-[11px] text-[#DA2128] font-semibold flex items-center gap-0.5 group-hover:translate-x-1 transition-transform">
                      Details <FiArrowUpRight className="h-3.5 w-3.5" />
                    </div>
                  </div>
                </motion.a>
              ))}
            </AnimatePresence>
          </motion.div>

          {/* Load More / Show Less Button */}
          {tenders.length > 3 && (
            <div className="pt-2 text-center">
              <button
                onClick={() => setShowAll(!showAll)}
                className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-5 py-2 text-xs font-semibold text-[#1a1a2e] shadow-sm hover:border-[#DA2128]/30 hover:text-[#DA2128] transition-all duration-200"
              >
                {showAll ? (
                  <>Show Less <FiChevronUp className="h-4 w-4" /></>
                ) : (
                  <>Load More Tenders ({tenders.length - 3} more) <FiChevronDown className="h-4 w-4" /></>
                )}
              </button>
            </div>
          )}
        </div>

        {/* Tender Intelligence Sidebar (Original Dark Design Restored) */}
        <div className="rounded-3xl bg-gradient-to-b from-[#1a1a2e] to-[#2a2a40] p-8 text-white shadow-2xl shadow-black/20 h-fit">
          <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 text-white shadow-lg backdrop-blur-sm">
            <FiSearch className="h-6 w-6" />
          </div>
          <h3 className="text-2xl font-semibold mb-4 font-['Outfit'] tracking-tight">Tender Intelligence</h3>
          <ul className="space-y-3.5">
            {intelligence.map((item) => (
              <li key={item} className="flex items-start gap-3 text-sm text-white/80">
                <FiCheckCircle className="h-4 w-4 text-[#F59C00] flex-shrink-0 mt-0.5" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          {/* <a href="#" className="mt-8 block w-full text-center rounded-full bg-[#F59C00] text-[#1a1a2e] font-bold py-3 text-sm shadow-xl shadow-[#F59C00]/25 hover:bg-[#FBBF24] transition-colors">
            Register for Tender Updates
          </a> */}
        </div>
      </div>
    </section>
  );
}